import { render, staticRenderFns } from "./OurServicesHome.vue?vue&type=template&id=44ed06e5&scoped=true"
import script from "./OurServicesHome.vue?vue&type=script&lang=js"
export * from "./OurServicesHome.vue?vue&type=script&lang=js"
import style0 from "./OurServicesHome.vue?vue&type=style&index=0&id=44ed06e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ed06e5",
  null
  
)

export default component.exports